import {formatDate} from "../utils/date.ts";
import React from "react";
import {BalloonEventModel} from "ts-core";

export interface DateBadgeProps {
    event: BalloonEventModel;
}

export const DateBadge: React.FC<DateBadgeProps> = ({event}: DateBadgeProps) => {
    return <div className="mt-2">
        <div className="inline-flex px-[8px] py-[4px] rounded-xl bg-dark-gray">
            <span className="text-white text-xs font-extrabold font-roboto leading-[10px]">
                {event.latestDate?.realEnd
                    ? event.latestDate?.formattedBeginEnd
                    : formatDate(event.latestDate?.start)}
            </span>
        </div>
    </div>
}